<template>
  <!-- 组长的报价系数抽取、组员的报价系数抽取查看 -->
  <div class="extract-content">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <!--     内容-->
    <div
      class="ccui-app-iframe-container-no-operate-detail"
      v-loading="loading"
    >
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">
              {{ breadcrumbData.titname }}
            </el-button>
          </div>
        </div>
        <!--分包件-->
        <template v-if="subPackageFlag">
          <el-tabs v-model="activeName" class="el-tabs__customize">
            <el-tab-pane
              v-for="(item_, index_) in tableData"
              :key="item_.packId"
              :label="item_.packName"
              :name="index_ + ''"
            >
              <el-table
                :data="item_.sscEvaExtractPackBOS"
                border
                :span-method="arraySpanMethod"
                class="dic-sub-table-style01"
                :cell-style="cellStyleHandle"
              >
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                  v-for="(item, index) in tableColumns"
                  :key="index"
                  :show-overflow-tooltip="true"
                  v-bind="item"
                  :align="item.align || 'center'"
                  :header-align="item.align || 'center'"
                >
                  <template slot-scope="{ row }">
                    <template v-if="item.isCal">
                      <template v-if="item.prop === 'priceAmount'">
                        <div class="priceClass">
                          <span
                            class="heighlight"
                            @click="handleSupply(row, item_)"
                            >{{
                              new BigNumber(row[item.prop]).toFormat(2)
                            }}</span
                          >
                        </div>
                      </template>
                      <div class="priceClass" v-else>
                        <span>{{
                          getAmountCount(item.prop, row[item.prop])
                        }}</span>
                      </div>
                    </template>
                    <span v-else>{{ row[item.prop] }} </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </template>
        <!--不分包件-->
        <template v-else>
          <el-table
            :data="tableData[0] && tableData[0].sscEvaExtractPackBOS"
            border
            :span-method="arraySpanMethod"
            class="dic-sub-table-style01"
            :cell-style="cellStyleHandle"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              v-for="(item, index) in tableColumns"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
              :align="item.align || 'center'"
              :header-align="item.align || 'center'"
            >
              <template slot-scope="{ row }">
                <template v-if="item.isCal">
                  <template v-if="item.prop === 'priceAmount'">
                    <div class="priceClass">
                      <span class="heighlight" @click="handleSupply(row)">{{
                        new BigNumber(row[item.prop]).toFormat(2)
                      }}</span>
                    </div>
                  </template>
                  <div class="priceClass" v-else>
                    <span>{{ getAmountCount(item.prop, row[item.prop]) }}</span>
                  </div>
                </template>
                <div v-else>{{ row[item.prop] }}</div>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="operate" v-if="exeStatus == 0 && isShowBtn">
          <div>
            <el-button
              v-preventReClick
              icon="icon-ccui-issue"
              type="text"
              @click="extractHandle"
              >抽取</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <el-dialog
      :visible.sync="supplierBidDetailsdialogVisible"
      title="分包商投标详细信息"
      width="1200px"
      v-if="supplierBidDetailsdialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supCode="formData.supCode"
        :supPackQuoteId="formData.supPackQuoteId"
        :packId="formData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import {
  qryEvaExtractPackList,
  dealEvaExtractPack
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
export default {
  name: "quotedPriceCoefficientExtract",
  components: { breadcrumbSourcing, supplierBidDetails },
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      isShowBtn: true,
      BigNumber: BigNumber,
      loading: false,
      // 激活的包件tab
      activeName: 0,
      breadcrumbData: {
        titname: "报价系数抽取",
        status: ""
      },
      // 是否分包 1分包0不分包
      subPackageFlag: "",
      // 包件列表
      packList: [],
      sscEvaExtractPackResultBOS: [],
      exeStatus: "",
      tableData: [],
      tableColumns: [
        {
          prop: "supName",
          label: "分包商名称",
          align: "left",
          width: 250
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "taxAmount",
          label: "税额",
          isCal: true,
          align: "center",
          width: 100
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          isCal: true,
          align: "right",
          width: 200
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          isCal: true,
          align: "right",
          width: 200
        },
        {
          prop: "coefficient",
          label: "系数",
          align: "center",
          width: 100
        },
        {
          prop: "guidePrice",
          label: "基准价",
          align: "center",
          width: 100
        }
      ],
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件Id
      },
      supplierBidDetailsdialogVisible: false
    };
  },
  mounted() {
    console.log(this.$router.history);
    this.getData();
  },
  methods: {
    // 表格合并方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 系数和基准价合并
      if (
        column.property === "coefficient" ||
        column.property === "guidePrice"
      ) {
        // 把被合并的单元格设置为0,避免多出列
        if (rowIndex != 0) {
          return [0, 0];
        }
        return [
          this.tableData[this.activeName].sscEvaExtractPackBOS
            ? this.tableData[this.activeName].sscEvaExtractPackBOS.length
            : 1,
          1
        ];
      }
    },
    cellStyleHandle({ row, column, rowIndex, columnIndex }) {
      // 系数、基准价
      if (
        column.property === "coefficient" ||
        column.property === "guidePrice"
      ) {
        console.log(1111);
        return "text-align:center";
      }
    },
    getData() {
      this.loading = true;
      Promise.all([this.qryEvaExtractPackList()])
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取列表
    qryEvaExtractPackList() {
      return new Promise((resolve, reject) => {
        qryEvaExtractPackList({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          purStep: this.$router.history.current.query.menuKey,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId
        })
          .then(res => {
            const { data, code } = res.data;
            if (code === "0") {
              // 导航中该环节状态的展示
              this.breadcrumbData.status =
                data.exeStatus === "0" ? "未抽取" : "已抽取";
              this.exeStatus = data.exeStatus;
              // 是否分包 1分包0不分包
              this.subPackageFlag = data.subpackageFlag == "1" ? true : false;
              this.sscEvaExtractPackResultBOS = JSON.parse(
                JSON.stringify(data.sscEvaExtractPackResultBOS)
              );
              // 数据处理
              this.tableData = [];
              data.sscEvaExtractPackResultBOS.map(item => {
                if (item.packStatus !== "1" && item.packName) {
                  item.packName = item.packName + "（已流标）";
                }
                // 系数、基准价
                item.coefficient = res.data.data.coefficient;
                item.guidePrice = res.data.data.guidePrice;
                this.tableData.push(item);
              });
              resolve();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 抽取按钮
    extractHandle() {
      const obj = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        isShowLoading: true,
        purStep: this.$router.history.current.query.menuKey,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      };
      dealEvaExtractPack(obj).then(res => {
        if (res.data.code === "0") {
          this.$message({
            message: res.data.message,
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          // 重新获取数据
          this.qryEvaExtractPackList();
        }
      });
    },
    getAmountCountShow(data) {
      let arr = ["taxAmount", "priceAmount", "noTaxPriceAmount"];
      if (arr.includes(data)) {
        return false;
      } else return true;
    },
    getAmountCount(prop, data) {
      let arr = ["taxAmount", "priceAmount", "noTaxPriceAmount"];
      if (arr.includes(prop)) {
        // console.log(data);
        return new BigNumber(data).toFormat(2);
      } else {
        // console.log(data);
        return data;
      }
    },
    //分包商跳转
    handleSupply(row, data) {
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supCode = row.supCode;
      if (data) {
        this.formData.packId = data.packId;
      } else {
        this.formData.packId = "";
      }
      this.supplierBidDetailsdialogVisible = true;
    }
  },
  beforeRouteEnter(to, from, next) {
    // 系数抽取查看页面不展示按钮
    if (to.name === "quotedPriceCoefficientView") {
      next(vm => {
        vm.isShowBtn = false;
        vm.breadcrumbData.titname = "报价系数抽取查看";
      });
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
@import "~@/config/styles/finereport.scss";

/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
  }
}

/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 0px !important;
}

/deep/ .el-tabs__content {
  position: initial;
}
/deep/ .el-tabs__customize {
  position: relative;
}

.ccui-app-iframe-container-detail-body {
  position: relative;
  .exportBtn {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999;
  }
}
/deep/ .el-tooltip {
  width: 100% !important;
}
/deep/ .el-tooltip > .priceClass {
  width: 100% !important;
  text-align: right !important;
}
</style>
